import { FronteggContext } from '@frontegg/rest-api';
import { Axios } from 'src/lib';
import { axiosAdmin } from 'src/lib/axios';
import {
  addOrganizationConfig,
  defaultNotificationTemplatesConfig,
  deleteOrganizationConfig,
  editOrganizationConfig,
  ehrFilterOrganizationConfig,
  filterOrganizationApiConfig,
  getAllActiveOrganizationConfig,
  getAllOrganizationConfig,
  getAllOrganizationPaginationConfig,
  getFronteggPlansConfig,
  getMirrorOrganizationConfig,
  getOrganizationByIdConfig,
  uploadOrganizationLogo,
} from '../lib/organization.url';
import {
  defaultNotificationTemplateSlice,
  ehrFilterOrganizationListSlice,
  filteredOrganizationTotalSlice,
  fronteggPlansSlice,
  getActiveOrganizationsListSlice,
  hQOrganizationsListSlice,
  getAllOrganizationDropdownSlice,
  getAllOrganizationListSlice,
  getOrganizationByIdSlice,
  organizationTotalSlice,
  organizationLoadingSlice,
  organizationUploadedLogoUrlSlice,
  logoUploadLoadingSlice,
  logoUploadSuccessSlice,
  dacCSVSettingsSlice,
  dacCSVSettingsLoadingSlice,
  patientSummaryNotificationSettingSlice,
  patientSummaryNotificationSettingLoadingSlice,
} from '../slices/organization.slice';
import { showToastSuccess } from 'src/utilities/toast';
import { showToastError } from 'src/utilities/errortoast';
import { superAdminLoadingSlice } from '../slices/condition.slice';
import { getErrorCode } from 'src/store';
import { settingsOrgFlag } from 'src/store/actions/appointment.action';

export const getAllOrganizationAction = () => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getAllOrganizationConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.Organization;
      if (result?.status === 200 && response) {
        dispatch(superAdminLoadingSlice(false));
        dispatch(getAllOrganizationListSlice(response));
        dispatch(getAllOrganizationDropdownSlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getAllOrganizationPaginationAction = (itemsPerPage) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    dispatch(filteredOrganizationTotalSlice(null));

    try {
      const { url } = getAllOrganizationPaginationConfig(itemsPerPage);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.Organization;
      if (result?.status === 200 && response) {
        dispatch(superAdminLoadingSlice(false));
        dispatch(getAllOrganizationListSlice(response));
        dispatch(getAllOrganizationDropdownSlice(response));
        dispatch(organizationTotalSlice(result?.data?.total));
      }
    } catch (e) {
      getErrorCode(500);
    }
  };
};

export const getOrganizationByIdAction = (org_id, setIsOpen, type) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = getOrganizationByIdConfig(org_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response =
        type === 'pagination'
          ? result?.data?.organization_details
          : result?.data;
      if (result?.status === 200 && response) {
        dispatch(superAdminLoadingSlice(false));
        if (type === 'pagination') {
          let list = [];
          if (
            typeof response === 'object' &&
            JSON.stringify(response) === '{}'
          ) {
            null;
          } else {
            list = [response];
          }
          dispatch(getAllOrganizationListSlice(list));
        } else {
          dispatch(getOrganizationByIdSlice(response));
          setIsOpen ? setIsOpen(true) : null;
        }
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

//This is used to display all orgs that are not deleted
export const getAllActiveOrganizationAction = () => {
  return async (dispatch) => {
    dispatch(organizationLoadingSlice(true));
    try {
      const { url } = getAllActiveOrganizationConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await axiosAdmin.get(url, { headers });
      const response = result?.data?.organizations;
      if (result?.status === 200 && response) {
        dispatch(getActiveOrganizationsListSlice(response));
      } else {
        // If no organizations in response, dispatch empty array
        dispatch(getActiveOrganizationsListSlice([]));
      }
      dispatch(organizationLoadingSlice(false));
    } catch (e) {
      dispatch(organizationLoadingSlice(false));
      dispatch(getActiveOrganizationsListSlice([]));
      showToastError('Error occurred while loading organizations');
    }
  };
};

export const getAllOPOrganizationAction = () => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await axiosAdmin.get('/organizations/op', { headers });
      const response = result?.data?.organizations;
      if (result?.status === 200 && response) {
        dispatch(hQOrganizationsListSlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getAllOpenDROrganizationAction = () => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await axiosAdmin.get('/organizations/opendr', { headers });
      const response = result?.data?.organizations;
      if (result?.status === 200 && response) {
        dispatch(hQOrganizationsListSlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

// Separate function to handle organization logo update
export const updateOrganizationLogoAPI = (orgId, logoUrl) => {
  return async (dispatch) => {
    dispatch(logoUploadLoadingSlice(true));
    dispatch(logoUploadSuccessSlice(null));
    try {
      if (!logoUrl) {
        showToastError('Please provide a logo URL');
        dispatch(logoUploadLoadingSlice(false));
        dispatch(logoUploadSuccessSlice(false));
        return { success: false, error: 'Logo URL is required' };
      }

      const token = FronteggContext.getAccessToken();

      const updateHeaders = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };

      const requestBody = {
        logo_url: logoUrl,
      };

      const updateResult = await Axios.put(
        `/organization/${orgId}/logo`,
        requestBody,
        { headers: updateHeaders }
      );

      const updateResponse = updateResult?.data;

      if (updateResult?.status === 200) {
        showToastSuccess('Organization logo updated successfully');
        dispatch(organizationUploadedLogoUrlSlice(logoUrl));
        dispatch(settingsOrgFlag());
        dispatch(logoUploadLoadingSlice(false));
        dispatch(logoUploadSuccessSlice(true));
        return { success: true, data: updateResponse };
      } else {
        dispatch(logoUploadLoadingSlice(false));
        dispatch(logoUploadSuccessSlice(false));
        return {
          success: false,
          error:
            updateResponse?.message || 'Failed to update organization logo',
        };
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to update organization logo';
      dispatch(logoUploadLoadingSlice(false));
      dispatch(logoUploadSuccessSlice(false));
      return { success: false, error: errorMessage };
    }
  };
};

export const uploadOrganizationLogoAction = (
  payload,
  navigate,
  updatedOrgData,
  type,
  orgId,
  user = false
) => {
  return async (dispatch) => {
    dispatch(logoUploadLoadingSlice(true));
    dispatch(logoUploadSuccessSlice(null));
    try {
      const { url } = uploadOrganizationLogo();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };

      // Step 1: Upload the file to get the URL
      const result = await Axios.post(url, payload, { headers });
      const logoUrl = result?.data?.url;

      if (result?.status != 200) {
        showToastError('Failed to upload logo');
        dispatch(logoUploadLoadingSlice(false));
        dispatch(logoUploadSuccessSlice(false));
        return { success: false, error: 'Failed to upload logo' };
      }

      // Step 2: Handle different scenarios
      if (user && type === 'isEditPage') {
        // Call the separate update function
        const updateResult = await dispatch(
          updateOrganizationLogoAPI(orgId, logoUrl)
        );

        if (updateResult.success) {
          dispatch(organizationUploadedLogoUrlSlice(logoUrl));
          return { success: true };
        } else {
          showToastError(updateResult.error);
          return { success: false, error: updateResult.error };
        }
      } else {
        dispatch(organizationUploadedLogoUrlSlice(logoUrl));
        type === 'isEditPage'
          ? dispatch(
              editOrganizationAction(orgId, updatedOrgData, navigate, logoUrl)
            )
          : dispatch(addOrganizationAction(navigate, updatedOrgData, logoUrl));
        dispatch(logoUploadLoadingSlice(false));
        dispatch(logoUploadSuccessSlice(true));
        return { success: true };
      }
    } catch (e) {
      showToastError('Failed to upload logo');
      dispatch(logoUploadLoadingSlice(false));
      dispatch(logoUploadSuccessSlice(false));
      return { success: false, error: 'Failed to upload logo' };
    }
  };
};

export const addOrganizationAction = (navigate, payload, logo_url) => {
  return async (dispatch) => {
    try {
      const { url } = addOrganizationConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const data = {
        ...payload,
        logo_url: logo_url,
      };
      const result = await Axios.post(url, logo_url ? data : payload, {
        headers,
      });
      if (result?.status === 201) {
        navigate('/superadmin');
        dispatch(getAllOrganizationPaginationAction(25));
      }
      showToastSuccess('Organization created successfully');
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const deleteOrganizationAction = (
  org_id,
  setIsOpen,
  isfilterOn,
  selectedOrganization
) => {
  return async (dispatch) => {
    try {
      const { url } = deleteOrganizationConfig(org_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.delete(url, { headers });
      if (result?.status === 200) {
        setIsOpen(false);
        isfilterOn
          ? dispatch(
              getOrganizationByIdAction(selectedOrganization, null, 'filter')
            )
          : dispatch(getAllOrganizationAction());
      }
      showToastSuccess('Organization deleted successfully');
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const editOrganizationAction = (org_id, payload, navigate, logo_url) => {
  return async (dispatch) => {
    try {
      const { url } = editOrganizationConfig(org_id);
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const data = {
        ...payload,
        logo_url: logo_url,
      };
      const result = await Axios.put(url, logo_url ? data : payload, {
        headers,
      });
      if (result?.status === 200) {
        navigate('/superadmin');
        dispatch(getAllOrganizationPaginationAction(25));
      }
      showToastSuccess('Organization updated successfully');
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const defaultNotificationTemplateAction = () => {
  return async (dispatch) => {
    try {
      const { url } = defaultNotificationTemplatesConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.notification_templates;
      if (result?.status === 200 && response) {
        dispatch(defaultNotificationTemplateSlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const filterOrganizationApiAction = (payload) => {
  return async (dispatch) => {
    dispatch(superAdminLoadingSlice(true));
    try {
      const { url } = filterOrganizationApiConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.post(url, payload, { headers });
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(getAllOrganizationListSlice(response));
        dispatch(superAdminLoadingSlice(false));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const ehrFilterOrganizationAction = () => {
  return async (dispatch) => {
    try {
      const { url } = ehrFilterOrganizationConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.ehr;
      if (result?.status === 200 && response) {
        dispatch(ehrFilterOrganizationListSlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getFronteggPlans = () => {
  return async (dispatch) => {
    try {
      const { url } = getFronteggPlansConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const result = await Axios.get(url, { headers });
      const response = result?.data?.items;
      if (result?.status === 200 && response) {
        dispatch(fronteggPlansSlice(response));
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getMirrorPractitionerDetails = (
  value,
  setFieldValue,
  setOrgData,
  setJsonInput,
  autoPopulateTimeFields,
  setPreferredAreaCodes
) => {
  return async () => {
    try {
      const { url } = getMirrorOrganizationConfig();
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const body = {
        mirror_org_id: value,
      };
      const result = await Axios.post(url, body, { headers });
      const response = result?.data?.response;
      if (result?.status === 200 && response) {
        const newOrgData = {
          settings: response?.settings,
          preferred_phone_area_codes: response?.preferred_phone_area_codes,
          org_setting_start_time: response?.notification_start_time,
          org_setting_end_time: response?.notification_end_time,
          frontegg_plan_ids: response?.frontegg_plan_ids,
        };
        autoPopulateTimeFields(
          response?.notification_start_time,
          response?.notification_end_time
        );
        setOrgData((prevOrgData) => ({
          ...prevOrgData,
          ...newOrgData,
        }));
        setPreferredAreaCodes(response?.preferred_phone_area_codes);
        setJsonInput(response?.settings);
        setFieldValue(
          'preferred_phone_area_codes',
          response?.preferred_phone_area_codes
        );
        setFieldValue('frontegg_plan_ids', response?.frontegg_plan_ids);
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const getDACCSVSettings = (selectedOrganizationUuid) => {
  return async (dispatch) => {
    try {
      dispatch(dacCSVSettingsLoadingSlice(true));

      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };

      const result = await Axios.get(
        `/v2/dac/settings?org_uuid=${selectedOrganizationUuid}`,
        { headers }
      );
      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(
          dacCSVSettingsSlice({
            practitioner: response?.config?.practitioner_id,
            time_period: response?.config?.start_time_period,
            timestamp_field: response?.config?.timestamp_field,
          })
        );
      }
      dispatch(dacCSVSettingsLoadingSlice(false));
    } catch (e) {
      if (e?.response?.status === 404) {
        dispatch(dacCSVSettingsSlice({}));
      }
      dispatch(dacCSVSettingsLoadingSlice(false));
    }
  };
};

export const saveDACCSVSettings = (payload) => {
  return async () => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${payload?.org_uuid}`,
        'Headless-Mode': true,
      };

      const finalPayload = {
        settings: {
          practitioner_id: payload?.practitioner_id,
          start_time_period: payload?.start_time_period,
          timestamp_field: payload?.timestamp_field,
        },
      };

      const result = await Axios.put(
        `/v2/dac/settings?org_uuid=${payload?.org_uuid}`,
        finalPayload,
        { headers }
      );

      const response = result?.data;
      if (result?.status === 200 && response) {
        showToastSuccess('DAC CSV settings updated');
      }
    } catch (e) {
      showToastError('Error occurred');
    }
  };
};

export const disableDACCSVSettings = (selectedOrganizationUuid) => {
  return async (dispatch) => {
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };

      const result = await Axios.delete(
        `/v2/dac/settings?org_uuid=${selectedOrganizationUuid}`,
        { headers }
      );

      const response = result?.data;
      if (result?.status === 200 && response) {
        dispatch(dacCSVSettingsSlice({}));
      }
    } catch (e) {
      if (e?.response?.status === 404) {
        dispatch(dacCSVSettingsSlice({}));
      } else if (e?.response?.status === 500) {
        showToastError('Error occurred');
      }
    }
  };
};

export const getPatientSummaryNotificationSetting = (payload) => {
  return async (dispatch) => {
    dispatch(patientSummaryNotificationSettingLoadingSlice(true));
    const token = FronteggContext.getAccessToken();
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Impersonate-Org-UUID': `${payload?.org_uuid}`,
      'Headless-Mode': true,
    };

    const result = await Axios.get('v2/patient-notifications/summary', {
      headers,
    });

    const response = result?.data;
    if (result?.status === 200 && response) {
      dispatch(patientSummaryNotificationSettingSlice(response?.enabled));
    } else {
      dispatch(patientSummaryNotificationSettingSlice(false));
    }
    dispatch(patientSummaryNotificationSettingLoadingSlice(false));
  };
};

export const savePatientSummaryNotificationSetting = (payload) => {
  return async () => {
    const token = FronteggContext.getAccessToken();
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Impersonate-Org-UUID': `${payload?.org_uuid}`,
      'Headless-Mode': true,
    };

    const finalPayload = {
      enabled: payload?.enabled,
    };

    const result = await Axios.put(
      'v2/patient-notifications/summary',
      finalPayload,
      {
        headers,
      }
    );

    const response = result?.data;
    if (result?.status === 200 && response) {
      console.log('Patient summary notification setting saved successfully');
    } else {
      console.log('Patient summary notification setting failed');
    }
  };
};
